import Markdown from '../../study/components/Markdown'
import { getReasoningGapContent, getReasoningGapSubmissions } from '../../service/reasoningGapService'
import { adaptReasoningGapEvents } from './reasoningGapReplay'
import './reasoningGap.scss'

// What View Student Data (commonUnit/RawDataPanel.jsx) needs for a Reasoning Gap session:
// `adapt` turns one student's telemetry into replayable events (reasoningGapReplay.js), and
// `replayOptions` sets up the replay screen like the student's page (task, explanation box,
// hidden tests, Run button). The task text is locked once anyone submits, so the current
// content is what every student saw.
export async function loadReasoningGapStudentData (sessionId) {
  const [data, content] = await Promise.all([
    getReasoningGapSubmissions(sessionId),
    getReasoningGapContent(sessionId),
  ])
  const submissions = new Map((data.submissions || []).map(s => [Number(s.user_id), s]))
  const tests = data.tests || []
  return {
    adapt: (events, userId) => adaptReasoningGapEvents(events, {
      submission: submissions.get(Number(userId)) || null,
      chat: (data.chats || {})[userId] || [],
      tests,
    }),
    replayOptions: {
      task: <div className="rg-task-md"><Markdown text={content.preview?.markdown || ''} /></div>,
      starterCode: content.preview?.starterCode || '',
      explanationPrompt: content.explanationPrompt || '',
      testCases: tests.map(t => ({ testName: t.description || t.id })),
      testCasesTitle: 'Hidden tests (run at each submit)',
      runLabel: 'Run',
      chatWelcome: null,
      showMouse: false,
      timelineMarkers: true,
      // Students often leave the quiz tab open and come back hours or days later.
      idleGapMs: 30 * 60 * 1000,
      initialSizes: { leftWidth: 320, rightWidth: 360, terminalHeight: 140 },
      // Opens full screen, without the decorative app bar, so code and explanation are
      // readable; each step highlights what changed (code, explanation or a chat message).
      startExpanded: true,
      showNavbar: false,
      showChanges: true,
      stepEdits: true,
      stepNote: 'Each change is a chat message, or what the student typed since their previous pause (code and explanation were saved about 4 s after typing stopped; keystrokes were not recorded). New items are green.',
    },
  }
}
